import { Pipe, PipeTransform } from '@angular/core';
import { Edition } from './edition-selector.component';

@Pipe({
  name: 'findItemEdition',
  pure: false,
  standalone: false,
})
export class FindItemEditionPipe implements PipeTransform {
  transform(selectedEditionId: string, editions: Edition[]): Edition | undefined {
    return editions?.find((edition) => (edition?.editionId ?? '') === (selectedEditionId ?? ''));
  }
}
